export default function DatenschutzPage() {
  return (
    <main className="container max-w-3xl py-16">
      <h1 className="font-display text-4xl font-bold tracking-tight text-foreground">Datenschutzerklärung</h1>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">1. Verantwortlicher</h2>
        <p className="text-muted-foreground leading-relaxed">
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
          David Federl<br />
          Breslauer Straße 22<br />
          82140 Olching<br />
          Telefon: <a href="tel:+49176281646701" className="text-primary hover:underline">+49 176 281646701</a><br />
          E-Mail: <a href="mailto:info@torflash.de" className="text-primary hover:underline">info@torflash.de</a>
        </p>
      </section>


      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">2. Erhebung und Speicherung personenbezogener Daten</h2>
        <p className="text-muted-foreground leading-relaxed">
          Wenn du dich bei Torflash registrierst, erheben und speichern wir folgende Daten: E-Mail-Adresse,
          Vereinsname, Vereinslogo sowie deine ausgewählten Vereinsfarben. Diese Daten werden auf der Infrastruktur
          unseres Backend-Anbieters (Lovable Cloud, basierend auf Supabase) innerhalb der EU gespeichert. Zweck der
          Verarbeitung ist die Erstellung deines Accounts sowie die automatisierte Generierung deiner Instagram
          Stories. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">3. Telegram-Integration</h2>
        <p className="text-muted-foreground leading-relaxed">
          Um dir die fertigen Stories zukommen zu lassen, speichern wir deine Telegram Chat-ID. Andere Inhalte deiner
          Telegram-Nachrichten werden nicht gelesen oder gespeichert. Lediglich der einmalige Verifizierungscode wird
          ausgewertet, um deinen Telegram-Account mit deinem Torflash-Konto zu verknüpfen.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">4. WhatsApp-Integration</h2>
        <p className="text-muted-foreground leading-relaxed">
          Wenn du die Zustellung deiner Grafiken per WhatsApp wählst, speichern wir deine Mobilfunknummer, um deinen
          Account zuzuordnen und dir die Stories zukommen zu lassen.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Der Versand erfolgt über die WhatsApp Business Platform (Cloud API) von Meta Platforms Ireland Ltd.,
          4 Grand Canal Square, Dublin 2, Irland. Dabei werden deine Telefonnummer und der Nachrichteninhalt an Meta
          übermittelt. Eine Übermittlung in die USA an Meta Platforms Inc. kann stattfinden; Grundlage hierfür sind
          die EU-Standardvertragsklauseln sowie das EU-US Data Privacy Framework.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Rechtsgrundlage für die Zustellung im Rahmen unseres Leistungsverhältnisses ist Art. 6 Abs. 1 lit. b DSGVO
          (Vertragserfüllung). Für darüber hinausgehende Nachrichten stützen wir die Verarbeitung auf deine Einwilligung
          gemäß Art. 6 Abs. 1 lit. a DSGVO, die du jederzeit widerrufen kannst.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Du kannst die WhatsApp-Zustellung jederzeit in deinem Account deaktivieren. Deine Mobilfunknummer wird dann
          gelöscht. Weitere Informationen zum Datenschutz bei WhatsApp findest du in der
          Datenschutzrichtlinie von WhatsApp/Meta:{" "}
          <a
            href="https://www.whatsapp.com/legal/privacy-policy-eea"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            https://www.whatsapp.com/legal/privacy-policy-eea
          </a>
          .
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">5. BFV-Daten</h2>
        <p className="text-muted-foreground leading-relaxed">
          Wir verarbeiten öffentlich zugängliche Liveticker- und Spielplandaten des Bayerischen Fußball-Verbands (BFV),
          um daraus automatisch Stories zu erstellen. Es werden keine personenbezogenen Daten von Spielerinnen oder
          Spielern gespeichert, die über die ohnehin öffentlich verfügbaren Informationen hinausgehen.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">6. Cookies</h2>
        <p className="text-muted-foreground leading-relaxed">
          Wir verwenden ausschließlich technisch notwendige Cookies, die für den Login und die Aufrechterhaltung
          deiner Session benötigt werden (Supabase Auth Session). Es werden derzeit keine Tracking- oder Analyse-Cookies
          eingesetzt.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">7. Hosting</h2>
        <p className="text-muted-foreground leading-relaxed">
          Diese Website wird über Lovable (Vercel, Cloudflare) gehostet. Das Backend (Datenbank, Authentifizierung,
          Edge Functions) läuft auf Lovable Cloud (basierend auf Supabase) in einer EU-Region. Beim Aufruf der
          Website werden technisch notwendige Daten (z. B. IP-Adresse, Browser, Zugriffszeitpunkt) verarbeitet, um den
          Dienst stabil und sicher bereitzustellen.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">8. Rechte der betroffenen Person</h2>
        <p className="text-muted-foreground leading-relaxed">
          Du hast jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung
          (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie
          Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Zusätzlich steht dir ein Beschwerderecht bei einer
          Datenschutz-Aufsichtsbehörde zu.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="font-display text-xl font-bold text-foreground">9. Kontakt für Datenschutz-Anfragen</h2>
        <p className="text-muted-foreground leading-relaxed">
          Für Anfragen zum Datenschutz erreichst du uns unter:{" "}
          <a href="mailto:info@torflash.de" className="text-primary hover:underline">info@torflash.de</a>
        </p>
      </section>
    </main>
  );
}
